import $ from 'jquery';
import { x, x0 } from '../../../_helpers';
import { setCookie } from '../../../_helpers/cookie-helper';
// Constants

// Stycky Nav
const startSticky = 700;
const endSticky = 100;

let didScroll;
let lastScrollTop = 0;
const delta = 5;
const navbarHeight = $('.tc-header').outerHeight();

export default class Header {
  constructor() {
    this.el = x0('.tc-header');
    if (!this.el) return;

    this.$win = $(window);
    this.$body = $('body');
    this.$document = $(document);

    this.$win.on('scroll', () => {
      if (this.$win.scrollTop() >= startSticky) {
        this.$body.addClass('nav--sticky');
      }
      if (this.$win.scrollTop() < endSticky) {
        this.$body.removeClass('nav--sticky');
      }
    });

    this.init();
  }

  manageStickyNav() {
    this.$win.on('scroll', () => {
      didScroll = true;
    });

    setInterval(() => {
      if (didScroll) {
        this.hasScrolled();
        didScroll = false;
      }
    }, 250);
  }

  hasScrolled() {
    const st = this.$document.scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      this.$body.removeClass('nav-down').addClass('nav-up');
    } else {
      // Scroll Up
      if (st + this.$win.height() < this.$document.height()) {
        this.$body.removeClass('nav-up').addClass('nav-down');
      }
    }

    lastScrollTop = st;
  }

  toggleMenu(e) {
    e.preventDefault();
    document.body.classList.toggle('-menu-open');
  }

  onMenuLinkClick(el, evt) {
    if (!el.nextElementSibling) {
      return;
    }
    evt && evt.preventDefault();
    this.activeItem = el.nextElementSibling;
    this.activeItem.classList.add('-active');
    this.menuSlider.classList.add('-active');
  }

  onMenuBackLinkClick() {
    this.activeItem.classList.remove('-active');
    this.menuSlider.classList.remove('-active');
    this.activeItem = null;
  }

  attachEvents() {
    const _this = this;

    //open menu
    if (this.menuBtn) {
      this.menuBtn.addEventListener('click', this.toggleMenu.bind(this));
    }

    window.addEventListener('resize', () => {
      document.body.classList.add('-resize');
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        document.body.classList.remove('-resize');
      }, 500);
    });

    $(_this.langMenus).each(function () {
      $(this).one('click', function () {
        // Update flag for instance while redirect is in progress
        $(this).parents(".tc-lang-btn").find(".tc-lang-btn-flag").html($(this).parent().html());

        // Set cookie and redirect
        setCookie('user-language', $(this).data('culture'), 3600);
        window.location.href = $(this).data('href');
      });
    });

    // Open/close lang menu dropdown on click
    $(document).on('click', function (e) {
      const $elem = $(e.target);
      if ($elem.hasClass("tc-lang-btn-head")) {
        $elem.parent().toggleClass('open-dropdown');
      } else {
        $('.tc-lang-btn').each(function () {
          $(this).removeClass('open-dropdown');
        });
      }
    });

  }

  init() {
    this.menuBtn = x0('[js-menu-btn]', this.el);
    this.menuLinks = x('[js-menu-link]', this.el);
    this.menuSublinkTitle = x('[js-menu-sublink]', this.el);
    this.menuSlider = x0('[js-menu-slider]', this.el);
    this.langMenus = x('[js-lang-key]');

    this.manageStickyNav();
    this.attachEvents();
  }
}
